import * as React from 'react';
import { colors } from '../../../index';

const IconCircleSix = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 21 22",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .046)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    opacity: 0.147,
    fill: "#FCFCFC",
    cx: 10.5,
    cy: 10.5,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.488 7v.766h-.166c-.703.013-1.262.221-1.678.624-.416.403-.657.97-.722 1.703.374-.43.884-.644 1.532-.644.617 0 1.111.218 1.48.653.37.436.554.999.554 1.688 0 .732-.2 1.317-.598 1.756-.398.44-.932.659-1.602.659-.68 0-1.231-.261-1.654-.783C8.211 12.9 8 12.228 8 11.405v-.347c0-1.307.279-2.306.837-2.997.557-.691 1.387-1.045 2.49-1.061h.16zm-1.186 3.2a1.44 1.44 0 00-.853.278c-.26.185-.44.418-.542.698v.331c0 .586.132 1.057.395 1.415.264.358.592.536.986.536.406 0 .726-.15.958-.448.233-.3.349-.691.349-1.176 0-.488-.118-.882-.354-1.183a1.134 1.134 0 00-.939-.451z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

export default IconCircleSix;